<div class="modal-header vobos-modal-header">
    <div class="titulo-vobos">
        <h4 class="modal-title" id="mondalAddCampaignTitle">{{ phase.name }}</h4>
        <span>Área: {{ vobo.area }} - {{ curr_diagram.medio }} - {{ curr_diagram.pop }} - {{ tituloPosicionesArte() }}</span>
    </div>
    <span *ngIf="isConsecutivo" class="consecutivo-vobos">
        Consecutivo {{ getEvaluatedConsecutivoCount() }}/{{ listEvaluate.length }}
    </span>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content class="vobos-dialog-content">
    <div class="modal-body vobos-modal-body">
        <mat-divider></mat-divider>
        <div>
         <mat-tab-group #tabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="vobos-tabs">
            <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="me-2 align-middle">assignment</mat-icon> Formulario
            </ng-template>
            <div class="row mt-3 vista-formulario">
                <!--<h6 class="floating-text-update">
                    <mat-icon class="align-middle">update</mat-icon>
                    Última actualización: 
                    <strong *ngIf="archivos.length>0">
                        {{ archivos[0].created_at | date : "dd/MM/yyyy" }} - {{ archivos[0].usuario }}
                    </strong>
                </h6>-->

                <div class="col-sm-8">
                  <div class="card h-100 p-0 visor-card">
                    <!-- Contenedor del visor de archivos -->
                    <div class="d-flex flex-column justify-content-center align-items-center h-100">

                        <!-- Controles de Zoom (solo para imágenes) -->
                        <div class="visor-archivo-header">
                            <div class="visor-archivo-titulo">
                                <mat-icon>insert_drive_file</mat-icon>
                                <div>
                                    <strong>{{ curr_diagram.pop }} - {{ tituloPosicionesArte() }}</strong>
                                    <span>{{ curr_diagram.medio }} - {{ totalArchivosVisor() }} {{ totalArchivosVisor() === 1 ? 'archivo' : 'archivos' }}</span>
                                </div>
                            </div>
                            <div class="controles-visor-compartido">
                              <div *ngIf="mostrandoArteCompartido && (arteCompartidoEsPdf || arteCompartidoEsMultiple)" class="paginas-pdf-compartido">
                                <button mat-stroked-button (click)="cambiarPaginaPdfCompartido(paginaPdfCompartido - 1)"
                                  [disabled]="paginaPdfCompartido <= 1" [matTooltip]="arteCompartidoEsMultiple ? 'Imagen anterior' : 'Página anterior'">
                                  <mat-icon>chevron_left</mat-icon>
                                </button>
                                <span>{{ arteCompartidoEsMultiple ? 'Imagen' : 'Página' }} {{ paginaPdfCompartido }} de {{ totalPaginasPdfCompartido || 1 }}</span>
                                <button mat-stroked-button (click)="cambiarPaginaPdfCompartido(paginaPdfCompartido + 1)"
                                  [disabled]="paginaPdfCompartido >= totalPaginasPdfCompartido" [matTooltip]="arteCompartidoEsMultiple ? 'Imagen siguiente' : 'Página siguiente'">
                                  <mat-icon>chevron_right</mat-icon>
                                </button>
                              </div>
                              <div *ngIf="mostrandoArteCompartido || isImageFile(selectedImage)" class="zoom-controls">
                                <button mat-stroked-button (click)="zoomOut()" matTooltip="Alejar imagen" [disabled]="nivelZoom <= 0.5">
                                    <mat-icon>remove</mat-icon>
                                </button>
                                <span>{{ nivelZoom * 100 | number:'1.0-0' }}%</span>
                                <button mat-stroked-button (click)="zoomIn()" matTooltip="Acercar imagen" [disabled]="nivelZoom >= 2.5">
                                    <mat-icon>add</mat-icon>
                                </button>
                              </div>
                            </div>
                        </div>

                        <!-- Visor de Archivos (unificado para uno o múltiples) -->
                        <div class="preview-wrapper text-center">
                            <!-- Flecha Izquierda (solo para carrusel) -->
                            <button *ngIf="!mostrandoArteCompartido && imagenesMultiple.length > 1" mat-icon-button class="nav-arrow left" [disabled]="currentIndex == 0"
                                    (click)="prevImage()">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>

                            <!-- Contenedor del medio (imagen, video, pdf) -->
                            <div #visorCompartido class="iframe-wrap" [class.visor-arte-compartido]="mostrandoArteCompartido">
                                <div *ngIf="isLoadingImg" class="loading-overlay">
                                    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
                     



                                </div>
                                <!-- Renderizado condicional del tipo de archivo -->
                                <div *ngIf="mostrandoArteCompartido" class="superficie-arte-compartido"
                                    [style.width.px]="anchoArteCompartido * nivelZoom"
                                    [style.height.px]="altoArteCompartido * nivelZoom">
                                    <img *ngIf="!arteCompartidoEsPdf" [src]="fuenteArteCompartido"
                                        alt="Arte compartido" draggable="false"
                                        (load)="imagenCompartidaCargada($event)"
                                        (error)="isLoadingImg = false" />
                                    <canvas *ngIf="arteCompartidoEsPdf" #lienzoPdfCompartido
                                        aria-label="Página del arte compartido en PDF"></canvas>
                                    <div *ngFor="let anotacion of anotacionesPaginaPdfCompartido()"
                                        class="area-arte-compartido"
                                        [class.aprobada]="anotacion.estado === 1"
                                        [class.rechazada]="anotacion.estado === 2"
                                        [ngStyle]="estiloAnotacionCompartida(anotacion)">
                                        <span [style.background]="anotacion.estado === 1 ? '#28a745' : (anotacion.estado === 2 ? '#dc3545' : (anotacion.color || '#3568ed'))">
                                            Pos. {{ anotacion.numero }} - {{ anotacion.alias }}{{ anotacion.estado === 1 ? ' - aprobado' : (anotacion.estado === 2 ? ' - rechazado' : ' - pendiente') }}
                                        </span>
                                    </div>
                                </div>

                                <img *ngIf="!mostrandoArteCompartido && isImageFile(selectedImage)" [src]="selectedImage" class="preview-img"
                                    [style.transform]="'scale(' + nivelZoom + ')'" [hidden]="isLoadingImg"
                                    (load)="isLoadingImg = false" (error)="isLoadingImg = false" />
                                <video *ngIf="!mostrandoArteCompartido && isVideoFile(selectedImage)" [src]="sanitizedSource" class="preview-video" [hidden]="isLoadingImg" controls loop muted></video>
                                <iframe *ngIf="!mostrandoArteCompartido && isPdfFile(selectedImage)" [src]="sanitizedSource" [hidden]="isLoadingImg" title="Vista previa Arte"></iframe>
                                <div *ngIf="!mostrandoArteCompartido && !selectedImage && !isLoadingImg" class="preview-box" style="padding: 10px;">
                                    <h6 class="text-muted">No se ha cargado ningún archivo</h6>
                                </div>
                                <!-- Contador de imágenes -->
                                <div *ngIf="!mostrandoArteCompartido && imagenesMultiple.length > 1" class="image-counter">
                                    {{ currentIndex + 1 }} / {{ imagenesMultiple.length }}
                                </div>

                            </div>

                            <!-- Flecha Derecha (solo para carrusel) -->
                            <button *ngIf="!mostrandoArteCompartido && imagenesMultiple.length > 1" mat-icon-button class="nav-arrow right" [disabled]="currentIndex == imagenesMultiple.length - 1"
                                    (click)="nextImage()">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                        </div>

                        <!-- Indicadores (solo para carrusel) -->
                        <div *ngIf="!mostrandoArteCompartido && imagenesMultiple.length > 1" class="d-flex justify-content-center gap-2 mt-3">
                                <span
                                *ngFor="let img of imagenesMultiple; let i = index"
                                class="indicator"
                                [class.active]="i === currentIndex"
                                (click)="changeImage(i)">
                                </span>
                            </div>
                        </div>
                  </div>
                </div>

      
                <div class="col-sm-4">
                    <div class="card h-100 formulario-card">
                        <div class="card-body formulario-card-body">
                            <h4 class="card-title">Formulario de aprobación - {{ vobo.area }}</h4>
                            <mat-divider></mat-divider>
                            <div *ngIf="!hasPermissions()" class="alerta-sin-permiso mt-3" role="alert">
                                <mat-icon>lock</mat-icon>
                                <div>
                                    <strong>Formulario en modo de solo lectura</strong>
                                    <span>No tienes permisos para aprobar o rechazar este VoBo.</span>
                                </div>
                            </div>
                            <form autocomplete="off" class="mt-3" [formGroup]="form">
                                <div class="preguntas-scroll">
                                    <small *ngIf="hasPermissions()">Todos los campos son obligatorios *</small>
                                    <div class="row pregunta-formulario" *ngFor="let q of form_vb">
                                        <div class="col-sm-8 pt-1">
                                            <span class="h6">{{q.nombre}}:</span>
                                        </div>
                                        <div class="col-sm-4">
                                            <mat-button-toggle-group #toggleGroup [disabled]="!hasPermissions()" (change)="setAnswer(q,$event.value)" appearance="legacy" class="mt-3">
                                                <mat-button-toggle [value]="true">SI</mat-button-toggle>
                                                <mat-button-toggle [value]="false">NO</mat-button-toggle>
                                            </mat-button-toggle-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-sm-4 pt-1">
                                        <span class="me-3 h6">Comentarios:</span>
                                    </div>
                                    <div class="col-sm-8 pt-2">
                                        <mat-form-field class="w-100 no-space-bottom" appearance="outline">
                                            <mat-label>Ingrese comentarios</mat-label>
                                            <input [disabled]="!hasPermissions()" matInput [(ngModel)]="comentario" [ngModelOptions]="{standalone: true}" value="">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-sm-4 pt-2">
                                        <span class="me-3 h6">Imágenes:</span>
                                    </div>
                                    <div class="col-sm-8 pt-2">
                                        <input id="fileUpload" type="file" multiple [disabled]="!hasPermissions()" (change)="onFileSelected($event)"/>
                                    </div>
                                </div>

                                <div *ngIf="modoArteCompartidoMultiple" class="aplicar-vobo-compartido mt-3">
                                    <h6>Aplicar VoBo a las posiciones: *</h6>
                                    <small>Las respuestas se guardarán individualmente en cada posición seleccionada.</small>
                                    <div *ngIf="posicionesElegiblesVobo().length === 0" class="alerta-sin-posiciones mt-2" role="alert">
                                        <span>Es necesario contar con al menos una posición pendiente, diagramada y con arte anotado para poder guardar la aprobación o el rechazo.</span>
                                    </div>
                                    <div class="seleccionar-todas-posiciones mt-2">
                                        <mat-checkbox
                                            [checked]="todasLasPosicionesSeleccionadas()"
                                            [indeterminate]="seleccionParcialDePosiciones()"
                                            [disabled]="!hasPermissions() || posicionesElegiblesVobo().length === 0"
                                            (change)="seleccionarTodasLasPosiciones($event.checked)">
                                            Seleccionar todas
                                        </mat-checkbox>
                                        <span>{{ posicionesSeleccionadasVobo().length }}/{{ posicionesElegiblesVobo().length }} seleccionadas</span>
                                    </div>
                                    <div class="posiciones-vobo-scroll mt-2">
                                        <div *ngFor="let posicion of posicionesVoboCompartido"
                                            class="posicion-vobo-compartido"
                                            [class.respondida]="posicion.estado === 1 || posicion.estado === 2"
                                            [class.no-disponible]="!posicion.diagrama || !posicion.anotacion">
                                            <mat-checkbox *ngIf="posicion.diagrama && posicion.anotacion && posicion.estado === 0"
                                                [(ngModel)]="posicion.seleccionada"
                                                [ngModelOptions]="{standalone: true}"
                                                [disabled]="!hasPermissions()">
                                            </mat-checkbox>
                                            <div class="posicion-vobo-info">
                                                <strong>
                                                    Pos. {{ posicion.numero }} - {{ posicion.alias }}
                                                    <ng-container *ngIf="(arteCompartidoEsPdf || arteCompartidoEsMultiple) && totalPaginasPdfCompartido > 1 && posicion.anotacion">
                                                        - {{ arteCompartidoEsMultiple ? 'Imagen' : 'Página' }} {{ posicion.anotacion.pagina || 1 }}
                                                    </ng-container>
                                                </strong>
                                                <span *ngIf="!posicion.diagrama" class="aviso-posicion">Esta posición no fue diagramada.</span>
                                                <span *ngIf="posicion.diagrama && !posicion.anotacion" class="aviso-posicion">Esta posición no tiene arte anotado.</span>
                                            </div>
                                            <button *ngIf="(arteCompartidoEsPdf || arteCompartidoEsMultiple) && totalPaginasPdfCompartido > 1 && posicion.anotacion
                                                && (posicion.anotacion.pagina || 1) !== paginaPdfCompartido"
                                                type="button" mat-icon-button color="primary" class="ir-pagina-posicion"
                                                (click)="cambiarPaginaPdfCompartido(posicion.anotacion.pagina || 1)"
                                                [matTooltip]="'Ir a la ' + (arteCompartidoEsMultiple ? 'imagen ' : 'página ') + (posicion.anotacion.pagina || 1)">
                                                <mat-icon>find_in_page</mat-icon>
                                            </button>
                                            <span *ngIf="posicion.estado === 1" class="badge bg-success">APROBADO</span>
                                            <span *ngIf="posicion.estado === 2" class="badge bg-danger">RECHAZADO</span>
                                            <span *ngIf="posicion.estado === 0 && posicion.diagrama && posicion.anotacion" class="badge bg-warning">PENDIENTE</span>
                                        </div>
                                    </div>
                                </div>


                                <div class="row mt-4">
                                    <div class="col-sm-12 text-end">
                                        <button *ngIf="hasPermissions()" (click)="limpiarForm()" mat-flat-button>Limpiar <mat-icon>clear</mat-icon></button>
                                        <button *ngIf="tieneArteDisponibleParaResponder()" [disabled]="!hasPermissions() || (modoArteCompartidoMultiple && posicionesSeleccionadasVobo().length === 0)" (click)="guardarRespuestas()" mat-raised-button class="bg-success text-white">Guardar <mat-icon>save</mat-icon></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            </mat-tab>
            <mat-tab><!-- archivos -->
                    <ng-template mat-tab-label>
                        <mat-icon class="me-2 align-middle">insert_drive_file</mat-icon> Archivos
                    </ng-template>
                    <div class="mt-4" style="min-height: 600px; max-height: 600px; overflow: auto;">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="align-middle"></span>
                            <div>
                                <a *ngIf="!medioPermiteArtesCompartidos() && archivos.length" href="{{archivos[0]?.file}}" target="_blank" mat-stroked-button color="primary">
                                Descarga último archivo <mat-icon class="align-middle ms-1">file_download</mat-icon></a>
                                <a *ngIf="medioPermiteArtesCompartidos() && artesCompartidosFase.length"
                                    [href]="artesCompartidosFase[0]?.file" target="_blank" mat-stroked-button color="primary">
                                    Descargar último arte compartido <mat-icon class="align-middle ms-1">file_download</mat-icon>
                                </a>
                            </div>
                        </div>
                            <div class="table-responsive text-nowrap">
                                <table class="table table-hover overflow-auto">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Archivo</th>
                                            <th>Tipo</th>
                                            <th>Cargado por</th>
                                            <th>Fecha de Registro</th>
                                            <th>Equipo</th>
                                            <th *ngIf="!modoArteCompartidoMultiple">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-border-bottom-0">
                                        <tr *ngFor="let p of archivosListado">
                                            <td>{{ p.id }}</td>
                                            <td>
                                                <a *ngIf="p.file != null" [href]="p.file" target="_blank">
                                                    {{ p.esArteCompartido ? (p.name || 'Arte compartido') : p.nombre }}
                                                </a>
                                                 <a *ngIf="p.file == null && !p.esArteCompartido" (click)="openModalImages(p.id)" style="cursor: pointer; color: #006eff">
                                                    {{ p.nombre }}
                                                </a>
                                                <span *ngIf="p.file == null && p.esArteCompartido">{{ p.name || 'Arte compartido' }}</span>
                                            </td>
                                            <td>
                                                {{ p.esArteCompartido ? 'Compartido' : 'Diagramación' }}
                                            </td>
                                            <td>{{ p.esArteCompartido ? nombreUsuarioArteCompartido(p) : p.usuario }}</td>
                                            <td>{{ p.created_at | date : 'dd/MM/yyyy HH:mma': '-0000' }}</td>
                                            <td>
                                                <span *ngIf="!p.esArteCompartido" class="badge bg-warning">{{ company_name || 'Cliente' }}</span>
                                                <span *ngIf="p.esArteCompartido && p.equipo" class="badge bg-info">
                                                    {{ p.equipo }}
                                                </span>
                                            </td>
                                            <td *ngIf="!modoArteCompartidoMultiple">
                                                <button *ngIf="p.esArteCompartido && !modoArteCompartidoMultiple" mat-stroked-button color="primary"
                                                    (click)="abrirHistorialArteCompartido()">
                                                    Ver compartidos
                                                    <mat-icon class="align-middle ms-1">open_in_new</mat-icon>
                                                </button>
                                            </td>
                                        </tr>
                                        
                                        <tr *ngIf="archivosListado.length == 0">
                                            <td [attr.colspan]="modoArteCompartidoMultiple ? 6 : 7"><i>No se ha cargado ningún archivo</i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                     
                    </div>
                </mat-tab>
                <mat-tab  *ngIf="!modoArteCompartidoMultiple && respuestas_copy.length > 0"><!-- Respuestas -->
                    <ng-template mat-tab-label>
                        <mat-icon class="me-2 align-middle">history</mat-icon> Historial de respuestas
                    </ng-template>

                        <div style="min-height: 600px; max-height: 600px; overflow: auto; padding-top: 10px;">
        <ng-container  *ngFor="let response of filterCurrent()">
            <h6>
                <span> <mat-icon class="align-middle">update</mat-icon>

                 Respuestas del formulario: 
                <strong>{{ response.fase}} - {{response.area}} - {{ response['Fecha de creacion'] | date : "dd/MM/yyyy"  }} </strong></span>
                <span> {{ response.Aprobado }}  por {{response.Usuario}}</span>            
            </h6>
            <div class="container">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Concepto</th>
                                    <th>Respuesta</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let resp of response.respuestas_arr">
                                    <td>
                                       {{resp.pregunta}}
                                    </td>
                                    <td>
                                        <span *ngIf="resp.respuesta == 'Aprobado'" class="badge bg-success"><span class="h6 text-white">SI</span></span>
                                        <span *ngIf="resp.respuesta != 'Aprobado'" class="badge bg-danger"><span class="h6 text-white">NO</span></span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <span><b>Comentario:</b> {{response.Comentario || "Sin comentario" }}</span>
                <button *ngIf="response.files_responses_array.length > 0" (click)="verImagenes(response)" mat-button>
                    <mat-icon>visibility</mat-icon> Ver archivos
                </button>
   
            </div>
    
        </ng-container>

        <!--<mat-divider></mat-divider>-->
        <h5 *ngIf="filterOld().length > 0" class="mt-3">
            <span> <mat-icon class="align-middle">youtube_searched_for</mat-icon> Historial de Respuestas del formulario</span>
        </h5>
        <div class="container">
            <div class="col-md-12 mb-3">
                <mat-accordion multi>
                    <mat-expansion-panel *ngFor="let response of filterOld()">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <mat-icon class="aling-middle text-muted me-2">event</mat-icon>
                             {{ response.fase}} - {{response.area}} - {{ response['Fecha de creacion'] | date : "dd/MM/yyyy"  }} {{ response.Aprobado }} por {{response.Usuario}}
 
                             <span> </span>  
                          </mat-panel-title>
                          <mat-panel-description>
                            <!--<span class="badge bg-label-info">{{  filterFilesCount(response.id) }} archivos adjuntos</span>-->
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Concepto</th>
                                            <th>Respuesta</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-border-bottom-0">
                                        <tr *ngFor="let resp of response.respuestas_arr">
                                            <td>
                                                {{resp.pregunta}}
                                            </td>
                                            <td>
                                                <span *ngIf="resp.respuesta == 'Aprobado'" class="badge bg-success"><span class="h6 text-white">SI</span></span>
                                                <span *ngIf="resp.respuesta != 'Aprobado'" class="badge bg-danger"><span class="h6 text-white">NO</span></span>
                                            </td>
                                        </tr>
                                      
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <span><b>Comentario:</b> {{response.Comentario || "Sin comentario"}}</span>
                        <button *ngIf="response.files_responses_array.length > 0" (click)="verImagenes(response)" mat-button>
                           <mat-icon>visibility</mat-icon> Ver archivos
                        </button>
                      </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>


                </mat-tab>
         </mat-tab-group>

                    <section *ngIf="modoArteCompartidoMultiple" class="promociones-posiciones-compartidas">
                      <h6>Promociones por posición</h6>
                      <div *ngIf="cargandoPromocionesCompartidas" class="cargando-promociones-compartidas">
                        <mat-spinner diameter="24"></mat-spinner>
                        <span>Cargando promociones...</span>
                      </div>
                      <mat-tab-group *ngIf="!cargandoPromocionesCompartidas && promocionesPorPosicionCompartida.length"
                        class="promociones-compartidas-tabs" mat-stretch-tabs="false" mat-align-tabs="start"
                        animationDuration="0ms" [dynamicHeight]="false">
                        <mat-tab *ngFor="let posicion of promocionesPorPosicionCompartida"
                          [label]="'Posición ' + posicion.numero">
                          <div class="encabezado-promociones-posicion">
                            <strong>Posición {{ posicion.numero }}</strong>
                            <span>{{ posicion.alias }} - {{ posicion.promociones.length }} promoción(es)</span>
                          </div>
                          <div class="tabla-promociones-compartidas" *ngIf="posicion.promociones.length; else posicionSinPromociones">
                            <table mat-table [dataSource]="promocionesPaginaPosicion(posicion)">
                              <ng-container *ngFor="let columna of columnasPromocionesCompartidas" [matColumnDef]="columna">
                                <th mat-header-cell *matHeaderCellDef>{{ columna }}</th>
                                <td mat-cell *matCellDef="let promocion">{{ promocion[columna] }}</td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="columnasPromocionesCompartidas; sticky: true"></tr>
                              <tr mat-row *matRowDef="let row; columns: columnasPromocionesCompartidas"></tr>
                            </table>
                          </div>
                          <mat-paginator *ngIf="posicion.promociones.length"
                            [length]="posicion.promociones.length"
                            [pageIndex]="posicion.pagina"
                            [pageSize]="posicion.limite"
                            [pageSizeOptions]="[5, 10, 25]"
                            showFirstLastButtons
                            (page)="cambiarPaginaPromociones(posicion, $event)">
                          </mat-paginator>
                          <ng-template #posicionSinPromociones>
                            <div class="sin-promociones-compartidas">Esta posición no tiene promociones asociadas.</div>
                          </ng-template>
                        </mat-tab>
                      </mat-tab-group>
                      <div *ngIf="!cargandoPromocionesCompartidas && !promocionesPorPosicionCompartida.length"
                        class="sin-promociones-compartidas">
                        No hay posiciones anotadas con promociones para mostrar.
                      </div>
                    </section>

                    <mat-accordion *ngIf="!modoArteCompartidoMultiple" class="promociones-acordeon">
                      <mat-expansion-panel [expanded]="false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>Promociones de la diagramación</mat-panel-title>
                          <mat-panel-description>{{ promotionFile?.length || 0 }} promoción(es)</mat-panel-description>
                          <button mat-raised-button color="primary" (click)="$event.stopPropagation(); sendSolicitud()"
                              matTooltip="Solicitar cambios en promociones" [disabled]="!hasChanges">
                            Solicitar Cambios <mat-icon>check</mat-icon>
                          </button>
                        </mat-expansion-panel-header>
                            <div class="table-responsive text-nowrap contenedor-promociones">
                                <table mat-table [dataSource]="dspromotionFile" matSort #sort="matSort" class="mat-elevation-z8" style="width: 100%;">
                                    <!-- Columnas Dinámicas -->
                                    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 170px;">{{column}}</th>
                                        <td mat-cell *matCellDef="let row" style="min-width: 170px;" [ngClass]="{'has-pending-request': getChange(row.solicitud, column)}">                                            
                                            <ng-container *ngIf="!isRowEditing(row) || !isColumnEditable(column)">
                                                <div class="edited-cell-new">
                                                    <ng-container *ngIf="getChange(row.solicitud, column) as change; else normalValue">
                                                        <span class="pending-change">{{ change.valor_nuevo }}</span> 
                                                    </ng-container>
                                                    <ng-template #normalValue>
                                                        {{ row[column.trim()] }} 
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="getChange(row.solicitud, column) as change;" class="edited-cell-original">
                                                    {{ change.valor_actual }}
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="isRowEditing(row) && isColumnEditable(column)">
                                                <input class="cell-input" [ngModel]="row[column] ?? ''" (ngModelChange)="row[column] = $event">
                                            </ng-container>
                                        </td>
                                    </ng-container>

                                    <!-- Columna de Acciones -->
                                    <ng-container matColumnDef="acciones" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef style="background: #e7e7e7; padding-left: 10px;">ACCIONES</th>
                                        <td mat-cell *matCellDef="let row" style="background: #e7e7e7; padding-left: 10px;">
                                            <ng-container *ngIf="!isRowEditing(row)">
                                                <button mat-icon-button (click)="startEditing(row)" matTooltip="Editar fila">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                <button mat-icon-button *ngIf="row.status === 'edited'" (click)="revertRowChanges(row)" matTooltip="Revertir cambios en fila">
                                                    <mat-icon>refresh</mat-icon>
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="isRowEditing(row)">
                                                <button mat-icon-button style="color: #2e7d32" (click)="acceptRowChanges(row)" matTooltip="Aceptar Cambios">
                                                    <mat-icon>check_circle</mat-icon>
                                                </button>
                                                <button mat-icon-button color="warn" (click)="revertRowChanges(row)" matTooltip="Cancelar edición">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </ng-container>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="allColumns; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: allColumns;" [ngClass]="getRowClass(row)"></tr>
                                  </table>
                            </div>
                            <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                      </mat-expansion-panel>
                    </mat-accordion>

        </div>
    </div>
</mat-dialog-content>
